import React, { useState, useEffect } from "react";
import {
    BrowserRouter as Router, NavLink
} from "react-router-dom";
import MenuNavbar from '../../../MenuNavbar';
import Floaticons from '../../../Floaticons';
import "../TabContentStyles.css";
import axios from "axios";
import baseUrl from "../../../../utils/Constants";
import { Breadcrumbs } from "@material-ui/core";
import OTSecurity from "./OperationSecurity/OTSecurity";

function PhysicalSecurityTab() {
    const [displaySkill, setDisplaySkill] = useState('OTSecurity');
    const [otSec, setotSec] = useState([]);

                const getCyberPhysicalSec = async () => {
            
                 const response = await axios.get(`${baseUrl}/cyberphysicalsec`, {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: localStorage.getItem("token")
                  }
                }
                ).then(res => {
                  console.log("getall", res);
                  if(res.data.result.length > 0){
            
                    const arr = res.data.result;
                    setotSec(arr.filter((item) => item.sub_practice.includes("OT Security")));
    
                  }
                  // setAllbooks(res.data.result);
                  
                  return res.data
                }).catch(err => {console.log("error")});
            
              }
            
                useEffect(() => {
                    getCyberPhysicalSec();
                }, [])

    return (
        <><div className="banner-container">
            <img src="images/Banner1.png" alt="banner" className="banner-img" />
            <MenuNavbar />
        </div>
            <Floaticons />
            <h2 className="ssa-heading">
                Security Specialization Academy
            </h2>
            <div className="TabPanelWrapper">
                <div className="SSA-breadcrumbLinks">
                    <Breadcrumbs separator="/" aria-label="breadcrumb">
                        <NavLink className="menu_title" to="/SecuritySpecializationAcademyNew">
                            <img src="images/SSA/Backbutton.png" class="breadcrumbBack" />
                            Cyber Physical Security
                        </NavLink>
                        {displaySkill === "OTSecurity" ? (
                            <NavLink className="menu_title" to="/CyberPhysicalSecurityNew#OTSecurity">
                                OT Security
                            </NavLink>
                        ) : (
                            ""
                        )}
                    </Breadcrumbs>
                </div>
                <div className="tabNavMenu">
                    <a
                        className={
                            displaySkill === "OTSecurity" ? "subtabActive" : "subtabInactive"
                        }
                        onClick={() => setDisplaySkill("OTSecurity")}
                        href="#OTSecurity"
                    >
                        <span>OT Security</span>
                    </a>
                </div>
                <div className="TabPanel-Wrap">
                    {displaySkill === "OTSecurity" ? (
                        <OTSecurity otSec = {otSec} />
                    ) : (
                        ""
                    )}
                </div>
            </div>
        </>
    );
}

export default PhysicalSecurityTab;